
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': 'Zgodba',
	'noDashboardFound': 'Zgodbe ni mogoče pridobiti. Ne obstaja več ali pa nimate zadostnih privilegijev za ogled.',
	'noDashboardCapability': 'Nimate zmožnosti za uporabljanje zgodb',
	'noDashboardPermision': 'Nimate zadostnih privilegijev za ogled te zgodbe',
	'defaultName': 'Nova zgodba',
	'storyProperties': 'Lastnosti zgodbe',
	'createAvDataStoryLabel': 'Zgodba',
	'createAvSlideShowLabel': 'Diaprojekcija',
	'createAvPanAndZoomLabel': 'Vodeno potovanje',
	'dashboard_save_success': 'Vaša zgodba je bila shranjena.',
	'cmEmptySelection': 'Zgodba je bila izbrisana. Poskusite shraniti kot novo zgodbo.',
	'createStoryTitle': 'Ustvarite zgodbo',
	'transitionStyleTitle': 'Slog s prehodom',
	'createButton': 'Ustvari',
	'cancelButton': 'Prekliči',
	'dashboardResetTitle': 'Ponastavi zgodbo',
	'dashboardResetMessage': 'Ali ste prepričani, da želite ponastaviti vse spremembe, uveljavljene za to zgodbo?',
	'dashboardResetToast': 'Zgodba je ponastavljena.',
	'filter_drag_and_drop_all_tabs': 'Povlecite in spustite podatke sem, da filtrirate vse scene.',
	'filter_drag_and_drop_current_tab': 'Povlecite in spustite podatke sem, da filtrirate to sceno.',
	'filterIconLabel_Global': 'Vse scene',
	'filterIconLabel_Tab': 'Ta scena',
	'filterIconTooltip_Global': 'Vse scene',
	'filterIconTooltip_Tab': 'Ta scena',
	'filterOverflowMenu_Global': 'Prelivni meni - vse scene',
	'filterOverflowMenu_Tab': 'Prelivni meni - ta scena',
	'renameScene': 'Preimenuj sceno',
	'duplicateScene': 'Podvoji sceno',
	'deleteScene': 'Izbriši sceno',
	'editTimelineHighlight': 'Urejanje označitve',
	'deleteTimelineHighlight': 'Izbriši označitev',
	'filter_includesAll': 'Vključuje vse',
	'timeline_highlight_moved_to': 'Označitev časovnice %{id} je bila premaknjena v %{time}',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': 'Izberi',
	'newDefaultStoryName': 'Zgodba: %{modelName}',
	'exportLabel': 'Shrani',
	'exportAsLabel': 'Shrani kot:',
	'exportDialogTitle': 'Shrani kot zgodbo',
	'exportDialogFooter': 'Gumba Shrani in Prekliči',
	'loadAfterExportLabel': 'Po shranitvi odpri zgodbo',
	'selectTemplateLabel': 'Izberi predlogo',
	'outOfBoundsWarningMessage': 'Nekateri gradniki delovne table so zunaj mreže in po izvozu morda ne bodo pravilno prikazani.',
	'emptyExploreCardsWarningMessage': 'Prazne kartice so bile med shranjevanjem zgodbe izbrisane.',
	'dashboard_export_success': 'Delovna tabla je bila uspešno shranjena kot zgodba.',
	'explore_export_success': 'Raziskovanje je bilo uspešno shranjeno kot zgodba.',
	'toastUpgradeDone': 'Vaša zgodba je bila nadgrajena. Shranite zdaj, da zagotovite optimalno zmogljivost.',
	'navigationMarker': 'Navigacijski označevalnik',
	'navigateMarkers': 'Navigacijski označevalniki',
	'navNextMarker': 'Naslednji označevalnik',
	'navPrevMarker': 'Prejšnji označevalnik',
	'navPrevMarkerAbbreviated': 'Prejšnji označevalnik',
	'timelineSettingsButton': 'Možnosti predvajanja',
	'autoPlay': 'Predvajaj vse scene',
	'loop': 'Zanka',
	'refreshData': 'Osveži ob zagonu',
	'slideshowLabel': 'Diaprojekcija',
	'panAndZoomLabel': 'Vodeno potovanje',
	'slideShowLayoutLabel': 'Postavitev diaprojekcije',
	'panAndZoomLayoutLabel': 'Postavitev vodenega potovanja',
	'panAndZoomLayoutFooter': 'Postavitev vodenega potovanja je zbirka scen na enem samem platnu. Ko se izvaja takšen tip zgodbe, se predstavitev po posameznih scenah pomika in jih povečuje/pomanjšuje v zaporednem vrstnem redu. Takšna postavitev se razlikuje od postavitve diaprojekcije, v kateri je vsaka scena predstavljena na novem platnu. Postavitev vodenega potovanja s tremi scenami, povezanimi s črtami, vam omogoča, da ustvarite vodoravno zaporedje scen. To je uporabno za prikaz časovnice.',
	'PanAndZoomLayout1': '5 scen, razporejenih v pravokotni obliki',
	'PanAndZoomLayout2': '4 scene, razporejene v obliki stopnišča, ki se vzpenja od leve proti desni',
	'PanAndZoomLayout3': '6 scen, razporejenih v pravokotni obliki',
	'PanAndZoomLayout4': '7 scen, razporejenih v pravokotni obliki s 6 majhnimi scenami na vrhu in 1 veliko sceno na dnu',
	'PanAndZoomLayout5': '3 scene, razporejene kot 2 majhni sceni na vrhu in 1 velika scena na dnu',
	'PanAndZoomLayout6': 'Zaporedje 4 scen, razporejenih vodoravno',
	'pageSelectWarning': 'Izberite sceno.',
	'noSceneTransitionLabel': 'Brez',
	'sceneTransitionPropertyLabel': 'Prehod med scenami',
	'animatedPathSceneTransitionLabel': 'Animirana pot',
	'sweepSceneTransitionLabel': 'Pometi',
	'storyTypeLabel': 'Tip zgodbe',
	'layoutLabel': 'Postavitev',
	'tabName_animation': 'Animacija',
	'propAniAnimation': 'Animacija',
	'propAniTypeEntrance': 'Animacija ob vstopu',
	'propAniDirectionIn': 'Smer vstopa',
	'propAniTypeExit': 'Animacija ob izhodu',
	'propAniDirectionOut': 'Smer izhoda',
	'propAniDirection': 'Smer',
	'propAniEntrance': 'Vstop',
	'propAniTypeEntranceSlideIn': 'Pojavitev z drsenjem',
	'propAniTypeEntranceFadeIn': 'Odtemnitev',
	'propAniTypeEntrancePivotIn': 'Zavrti navznoter',
	'propAniTypeEntranceScaleIn': 'Pojavitev s prilagoditvijo velikosti',
	'propAniTypeEntranceShrinkIn': 'Pomanjšaj navznoter',
	'propAniDirectionInLeft': 'Z leve',
	'propAniDirectionInRight': 'Z desne',
	'propAniDirectionInTop': 'Z vrha',
	'propAniDirectionInBottom': 'Z dna',
	'propAniExit': 'Izhod',
	'propAniTypeExitSlideIn': 'Umik z drsenjem',
	'propAniTypeExitFadeIn': 'Zatemnitev',
	'propAniTypeExitPivotOut': 'Zavrti navzven',
	'propAniTypeExitScaleIn': 'Umik s prilagoditvijo velikosti',
	'propAniTypeExitExpandOut': 'Razširi navzven',
	'propAniDirectionOutLeft': 'Proti levi',
	'propAniDirectionOutRight': 'Proti desni',
	'propAniDirectionOutTop': 'Proti vrhu',
	'propAniDirectionOutBottom': 'Proti dnu',
	'propAniEntranceTime': 'Začni ob (sek.):',
	'propAniExitTime': 'Končaj ob (sek.):',
	'animationNoEntranceText': 'Začetna animacija se ne izvede, če je gradnik na začetku scene.',
	'animationNoExitText': 'Končna animacija se ne izvede, če je gradnik na koncu scene.',
	'propAniTypeDataEntrance': 'Vstop podatkov',
	'propAniRevealDuration': 'Trajanje animacije vhoda',
	'timelineAnimationProperties': 'Odpri lastnosti animacije',
	'scenesPropertiesSection': 'Scene',
	'editStoryCoachMarkTitle': 'Urejanje zgodbe',
	'editStoryCoachMarkContents': 'Kliknite ikono svinčnika, da uredite to zgodbo.',
	'addDataStoryCoachMarkContents': 'Povlecite in spustite podatke iz podokna s podatki v zgodbo.',
	'expandSceneCoachmarkTitle': 'Odpri časovnico',
	'expandSceneCoachmarkContents': 'Animacija prizora s prilagoditvijo vidljivosti objekta na podlagi časa in trajanja.',
	'overviewCoachmarkTitle': 'Scene pregleda',
	'overviewCoachmarkContents': 'S scenami pregleda na začetku in koncu zgodbe prikažete celotno sliko vseh scen. V sceni pregleda kliknite in povlecite sceno, da jo zamenjate z drugo sceno. Scene pregleda lahko pokažete ali skrijete v lastnostih zgodbe.',
	'animatedPathCoachmarkTitle': 'Animirana pot',
	'animatedPathCoachmarkContents': 'Če želite animirati objekt iz enega prizora v drugega, podvojite prizor z objektom. Nato premaknite, spremenite velikost ali zasukajte podvojeni objekt v novem prizoru.',
	'propShowStoryOverviewFirstSlide': 'Pokaži vse scene na začetku',
	'propShowStoryOverviewLastSlide': 'Pokaži vse scene na koncu',
	'storySceneSingleCountLabel': '1 scena',
	'storySceneCountLabel': 'Št. scen: %{count}',
	'storySceneRangeCountLabel': 'Scena %{index} od %{count}',
	'storySceneExpand': 'Odpri časovnico',
	'storySceneActionMenu': 'Zaženi meni možnosti scene',
	'timelineRightContainerLabel': 'Kontrolna skupina gumba Časovnica',
	'timelineViewLabel': 'Časovnica',
	'timelineZoomFit': 'Povečaj, da se prilega',
	'timelineZoomIn': 'Povečaj',
	'timelineZoomOut': 'Pomanjšaj',
	'timelinePositionIndicator': 'indikator položaja časovnice na položaju %{position}',
	'timelinePositionIndicatorMoveLeftTo': 'indikator položaja časovnice je bil premaknjen v levo na %{position}',
	'timelinePositionIndicatorMoveRightTo': 'indikator položaja časovnice je bil premaknjen v desno na %{position}',
	'sceneStart': 'Skoči na začetek prizora na položaju %{position}',
	'sceneEnd': 'Skoči na konec prizora na položaju %{position}',
	'timelineHighlightTitle': 'Označi',
	'addTimelineHighlight': 'Dodaj označitev',
	'addSceneBtnTitle': 'Dodaj novo sceno s privzeto predlogo',
	'addSceneChevronBtnTitle': 'Izberite predlogo scene',
	'timelinePlay': 'Predvajaj',
	'timelinePause': 'Začasno zaustavi',
	'sceneNavigation': 'Navigacija po scenah',
	'navNextScene': 'Naslednja scena',
	'navPrevScene': 'Prejšnja scena',
	'navPrevSceneAbbreviated': 'Prejšnja scena',
	'navExitFullScreen': 'Izhod iz celozaslonskega načina',
	'navToggleOverview': 'Preklopi pregled',
	'rowNumber': 'Vrstica %{number}',
	'overviewBtnLabel': 'Pregled',
	'sceneListStart': 'Začetek pregleda',
	'sceneListEnd': 'Konec pregleda',
	'timelineLeftHandle': 'leva ročka za %{name}',
	'timelineRightHandle': 'desna ročka za %{name}',
	'timelineLeftHandleNoTitle': 'leva ročka',
	'timelineRightHandleNoTitle': 'desna ročka',
	'timelineMoveLeft': 'Premakni %{object} v levo',
	'timelineMoveRight': 'Premakni %{object} v desno',
	'timelineMoveWidget': 'gradnik časovnica je bil premaknjen na %{newStartTime} in %{newEndTime}',
	'timelineMoveWidgetStartTime': 'čas začetka na gradniku časovnica je bil spremenjen na %{newStartTime}',
	'timelineMoveWidgetEndTime': 'čas konca na gradniku časovnica je bil spremenjen na %{newEndTime}',
	'timelineMoveWidgetDown': 'gradnik časovnica je bil premaknjen navzdol',
	'timelineMoveWidgetUp': 'gradnik časovnica je bil premaknjen navzgor',
	'addSceneTitle': 'Dodaj sceno',
	'blankSceneLayout': 'Prazno',
	'titleSceneLayout': 'Naslov s podnaslovom',
	'sceneLayout1': 'Naslov z besedilom zraven ene vizualizacije',
	'sceneLayout2': 'Naslov z eno vizualizacijo',
	'sceneLayout3': 'Naslov z dvema vizualizacijama',
	'sceneLayout4': 'Večnamenski',
	'sceneLayout5': 'Brez naslova z besedilom zraven ene vizualizacije',
	'sceneLayout6': 'Večnamenski 2 po 2',
	'sceneLayout7': 'Večnamenski 2 zraven 1',
	'sceneLayout8': 'Večnamenski 1 zraven 2',
	'sceneLayout9': 'Večnamenski 1 prek 2',
	'sceneLayout10': 'Večnamenski 2 prek 1',
	'sceneLayout11': 'Večnamenski 4 prek 1',
	'sceneLayout12': 'Večnamenski 1 prek 1 zraven 2 po 2 prek 1',
	'titleWidgetPlaceholderText': 'Sem vnesite naslov',
	'subtitleWidgetPlaceholderText': 'Sem vnesite podnaslov',
	'createStoryViewTitle': 'Ustvari zgodbo',
	'defaultStoryName': 'Nova zgodba',
	'screenshot_label': 'Zgodba %{title}',
	'screenshot_label_scene': 'Scena %{sceneTitle} zgodbe %{title}',
	'filmstripHandleOpenLabel': 'Odpri izbirnik scen',
	'filmstripHandleCloseLabel': 'Zapri izbirnik scen'
});
